<div class="window height-modal-subdetails">
  <div class="window-caption">
    <span class="icon mif-tag fg-green"></span>
    <span class="title">{{ 'AFFECTATION_RETRAIT.TITLE' | translate }}</span>
    <div class="buttons">
      <span class="btn-min"></span>
      <span class="btn-max"></span>
      <span class="btn-close js-dialog-close" (click)="onClose()"></span>
    </div>
  </div>

  <div class="window-content pl-2 pr-2 pb-0">
    <div class="row" *ngIf="componentType === 'CLIENT' || componentType === 'FOURNISSEUR'">
    </div>

    <div class="row">
      <!-- Partie disponible -->
      <div class="col-md-12 col-lg-6">
        <div class="row p-0 m-0">
          <div class="card p-0 m-0">

            <div class="col-md-12" *ngIf="componentType === 'CLIENT' || componentType === 'FOURNISSEUR'">
              <label>
                {{ 'AFFECTATION_RETRAIT.CODE_JOURNAL' | translate }}
                {{ componentType === 'CLIENT' ? ('AFFECTATION_RETRAIT.VENTE' | translate) : ('AFFECTATION_RETRAIT.ACHAT' | translate) }}
                <sup class="red">*</sup>
              </label>
              <ng-select [(ngModel)]="journal"
                         (search)="onChangeSearch($event)"
                         (focus)="onFocused($event)">
                <ng-option *ngFor="let car of listCodeJournaux" [value]="car?.joNum">
                  <ng-container *ngIf="car?.joIntitule">
                    {{ car?.joIntitule }}
                  </ng-container>
                </ng-option>
              </ng-select>
              <small style="color: red" *ngIf="submitted && !journal">
                {{ 'AFFECTATION_RETRAIT.CODE_JOURNAL_REQUIRED' | translate }}
              </small>
            </div>

            <div class="col-md-12 custom-input-search">
              <m4-input placeholder="{{ 'AFFECTATION_RETRAIT.PLACEHOLDER' | translate }}"
                        [search-button]="true"
                        (keyup)="clickEventDispo($event)">
              </m4-input>
            </div>

            <div class="col-md-12" style="height: 175px; overflow-y: scroll;">
              <table class="table table-border cell-border subcompact striped m-0">
                <thead>
                <tr style="background-color:#3c6478">
                  <th class="fg-white">
                    {{ disponible | translate }}
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr class="clickable"
                    *ngFor="let dispo of listeDisponible | paginate: { id: 'disponible', currentPage: currentPageDispo + 1, itemsPerPage: itemsPerPageDispo, totalItems: totalItemsDispo }; let i=index"
                    (click)="onSelectLineDispo(dispo, habilitation.idObjetClick)"
                    [ngClass]="{'bg-gray' :  isLineSelectedDispo(dispo)}">
                  <td>
                    <span class="label">{{ dispo[rowAttrib] | translate }}</span>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <div class="cell-md-12 text-center">
              <button m4-button class="mr-2"
                      [disabled]="addLine.length <= 0"
                      *ngIf="authService.isVisible(habilitation.idObjetAjouter)"
                      (click)="affecter()">
                {{ 'AFFECTATION_RETRAIT.AJOUTER' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Partie affectés -->
      <div class="col-md-12 col-lg-6">
        <div class="row p-0 m-0">
          <div class="card p-0 m-0">
            <div class="col-md-12" *ngIf="componentType === 'CLIENT' || componentType === 'FOURNISSEUR'">
              <label>
                {{ 'AFFECTATION_RETRAIT.CODE_JOURNAL_CAISSE' | translate }}
                <sup class="red">*</sup>
              </label>
              <ng-select [(ngModel)]="journalJONUMCaisse"
                         (search)="onChangeSearchJONUMCaisse($event)"
                         (focus)="onFocusedJONUMCaisse($event)">
                <ng-option *ngFor="let car of listCodeJournauxJONUMCaisse" [value]="car?.joNum">
                  <ng-container *ngIf="car?.joIntitule">
                    {{ car?.joIntitule }}
                  </ng-container>
                </ng-option>
              </ng-select>
              <small style="color: red" *ngIf="submitted && !journalJONUMCaisse">
                {{ 'AFFECTATION_RETRAIT.CODE_JOURNAL_CAISSE_REQUIRED' | translate }}
              </small>
            </div>

            <div class="col-md-12 custom-input-search">
              <m4-input placeholder="{{ 'AFFECTATION_RETRAIT.PLACEHOLDER' | translate }}"
                        [search-button]="true"
                        (keyup)="clickEventAffecte($event)">
              </m4-input>
            </div>

            <div class="col-md-12" style="height: 175px; overflow-y: scroll;">
              <table class="table table-border cell-border subcompact striped m-0">
                <thead>
                <tr style="background-color:#3c6478">
                  <th class="fg-white">
                    {{ affecte | translate }}
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr class="clickable"
                    *ngFor="let affect of listeAffecte | paginate: { id: 'affecte', currentPage: currentPageAffect + 1, itemsPerPage: itemsPerPageAffect, totalItems: totalItemsAffect }; let i=index"
                    (click)="onSelectLineAffect(affect, habilitation.idObjetClick)"
                    [ngClass]="{'bg-gray' :  isLineSelectedAffect(affect)}">
                  <td>
                    <span class="label">{{ affect[rowAttrib] | translate }}</span>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <div class="cell-md-12 text-center">
              <button m4-button class="mr-2"
                      [disabled]="removeLine.length <= 0"
                      *ngIf="authService.isVisible(habilitation.idObjetRetirer)"
                      (click)="retrait()">
                {{ 'AFFECTATION_RETRAIT.RETIRER' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
